module.exports = __webpack_public_path__ + "static/media/gm.4b029b13.svg";